import React, { useState, useEffect } from "react";
import { useLoginCheck } from "../../hooks/useLoginCheck";

function WsPatt2509RequestsPage() {
  useLoginCheck();
  const [workshopData, setWorkshopData] = useState({});

  const fetchWsPatt2509RequestsData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_ws_patt_2509_requests/`);
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      setWorkshopData(data);
    } catch (error) {
      console.error("データの取得中にエラーが発生しました:", error);
    }
  };

  useEffect(() => {
    fetchWsPatt2509RequestsData();
  }, []);

  const workshopNames = {
    workshop_1: "ベーシック",
    workshop_2: "コレオ",
    workshop_3: "コレオ中級",
  };

  const getTotalAmount = () => {
    return workshopData.total_amount || 0;
  };

  const renderWorkshopSection = (workshopKey, workshopName) => {
    const workshop = workshopData[workshopKey];
    if (!workshop || !workshop.users || workshop.users.length === 0) {
      return (
        <div key={workshopKey} className="workshop-column">
          <div className="workshop-section">
            <h3 className="workshop-title">{workshopName} (参加者: 0名)</h3>
          </div>
        </div>
      );
    }

    return (
      <div key={workshopKey} className="workshop-column">
        <div className="workshop-section">
          <h3 className="workshop-title">
            {workshopName} (参加者: {workshop.users.length}名)
          </h3>

          <ul className="customer-grid customer-header">
            <li className="cell">No</li>
            <li className="cell">名前</li>
            <li className="cell">メール</li>
            <li className="cell">電話番号</li>
          </ul>

          {workshop.users.map((user, i) => (
            <ul key={user.id} className="customer-grid">
              <li className="cell">{i + 1}</li>
              <li className="cell">{user.name}</li>
              <li className="cell">{user.email}</li>
              <li className="cell">{user.phone}</li>
            </ul>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="ws-patt-page">
      <div className="page-container">
        <div className="total-amount-section">
          <h3 className="total-amount-title">
            合計金額: ¥{getTotalAmount().toLocaleString()}
          </h3>
        </div>

        <div className="workshop-grid">
          {Object.keys(workshopNames).map((workshopKey) =>
            renderWorkshopSection(workshopKey, workshopNames[workshopKey])
          )}
        </div>
      </div>
    </div>
  );
}

export default WsPatt2509RequestsPage;
